import React, { memo } from "react";

import Icon from "@/components/ui/Icon/Icon";
import { IMortgageCalculatorLabelAndIcon } from "@/types";

const MortgageCalculatorLabelAndIcon: React.FC<IMortgageCalculatorLabelAndIcon> = ({ label = "", icon, iconTitle = "" }) => {
  return (
    <div className="flex items-center">
      <h6 className="uppercase font-secondary text-s">{label}</h6>
      {icon && <Icon className="stroke-black mr-xs ml-xxs" name={icon} size="12" title={iconTitle} />}
    </div>
  );
};

export default memo(MortgageCalculatorLabelAndIcon);
